import { forOwn } from '../../../../lib/utilities';
import { ReduceStore } from 'flux/utils';
import ACTION_TYPES from '../../constants/action_types';
import POSTCODE_CONSTANTS from '../../constants/postcode';
import { CheckboxValues } from '../../constants/filter/checkbox_values';
import { FilterActions } from '../../constants/filter/filter_actions';
import { Filters } from '../../constants/filter/filters';
import { FilterTypes } from '../../constants/filter/filter_types';
import { getTypeByFilter } from '../../helper/filters/get_type_by_filter';

export class CatalogFilterStoreClass extends ReduceStore {
    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CATALOG_FILTER_ACTION) {
            switch (action.type) {
                case FilterActions.UPDATE_FILTER:
                    let change = false;

                    forOwn(action.payload, (value, key) => {
                        if (typeof state[key] !== 'undefined') {
                            const filterType = getTypeByFilter(key);
                            switch (filterType) {
                                case FilterTypes.BOOLEAN_FILTER:
                                    if (state[key] && !value) {
                                        change = true;
                                        state[key] = CheckboxValues.OFF;
                                    } else if (!state[key] && value) {
                                        change = true;
                                        state[key] = CheckboxValues.ON;
                                    }

                                    break;

                                default:
                                    if (state[key] !== value) {
                                        change = true;
                                        if (key === Filters.MANUFACTURER && value === '') {
                                            state[Filters.MODEL] = '';
                                        }
                                        state[key] = value;
                                    }
                            }
                        }
                    });

                    if (change) {
                        this.__emitChange();
                    }
            }
        }

        if (source === ACTION_TYPES.POSTCODE_ACTION) {
            switch (action.type) {
                case POSTCODE_CONSTANTS.APPLY_POSTCODE_ACTION:
                    if (action.payload !== state[Filters.POSTCODE]) {
                        state[Filters.POSTCODE] = action.payload;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}
